// extracted by mini-css-extract-plugin
module.exports = {"visualEditor":"VisualEditor_visualEditor__1sokt","inputElement":"VisualEditor_inputElement__2vmoO","input":"VisualEditor_input__1HkYF","inputType":"VisualEditor_inputType__1ommz"};